import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.js';
import MUIAgileDashboard from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MUIAgileDashboard />
  </React.StrictMode>
);
